module.exports = __webpack_public_path__ + "dbceae911fce15657a854544a48809dd.svg";